export default "__VITE_ASSET__BpiV4_T0__"